// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__29RBE","header":"MessagesList_header__34Tao","chat":"MessagesList_chat__Wx--0"};